import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaAward, FaGift, FaSimCard, FaGripHorizontal  } from "react-icons/fa";
import lumina from "../../Assets/luminar-logo.png";
import Cerulean from "../../Assets/cerulean-logo.png";



function Home3() {
  return (
    <Container fluid className="home-features-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-description">
          <div className="dreamit-section-title"><h4 style={{ fontSize: "2rem", marginBottom: "3rem"}}>Rewards</h4></div>
           
            <p class="align-centre">
            Fontana is built on a powerful vision: <br/>
            Create a more inclusive and equitable society. Fontana want to create opportunities to improve your Crypto Saga, connect with a like-minded community, and achieve your aspirations.
            </p>
              
          </Col>

          </Row>
                    <Row>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="feature-single-box upper1 flex-fill d-flex flex-column">
                                <div className="feature-box-inner flex-fill d-flex flex-column">
                                    <div className="feature-icon reward-icon" style={{ color: '#f9d923' }}>
                                        <img
                                            src={lumina}
                                            alt="Lumina token Lumieria Metaverse"
                                            className="reward-icon-img"
                                        />
                                    </div>
                                    <div className="feature-title">
                                        <h3>Lumina </h3>
                                        <p>Metaverse Token, generated based on trading activity on FONTANA. Users can sell and buy on P2P market.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="feature-single-box upper1 flex-fill d-flex flex-column">
                                <div className="feature-box-inner flex-fill d-flex flex-column">
                                    <div className="feature-icon reward-icon" style={{ color: '#00c896' }}>
                                        <FaAward />
                                    </div>
                                    <div className="feature-title">
                                        <h3>Realityverse Rewards</h3>
                                        <p>Rewards points "RVP" will be generated when trading FONTANA Token. These points can be redeemed to buy real world goods.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="feature-single-box upper2 flex-fill d-flex flex-column">
                                <div className="feature-box-inner flex-fill d-flex flex-column">
                                    <div className="feature-icon reward-icon" style={{ color: '#ff5e57' }}>
                                        <FaGift />
                                    </div>
                                    <div className="feature-title">
                                        <h3>Bonus Prize Pool</h3>
                                        <p>A prize pool for active traders, some project participants and for Liquidity Pool contributors. </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="feature-single-box upper3 flex-fill d-flex flex-column">
                                <div className="feature-box-inner flex-fill d-flex flex-column">
                                    <div className="feature-icon reward-icon" style={{ color: '#3a86ff' }}>
                                        <FaSimCard />
                                    </div>
                                    <div className="feature-title">
                                        <h3>NFT's and Collectibles</h3>
                                        <p>As a part of Community giveaway innitiative, NFT's pieces issued for collectibles, puzzels, metaverse items, and many more.... </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="feature-single-box upper4 flex-fill d-flex flex-column">
                                <div className="feature-box-inner flex-fill d-flex flex-column">
                                    <div className="feature-icon reward-icon" style={{ color: '#ffbe0b' }}>
                                        <FaGripHorizontal />
                                    </div>
                                    <div className="feature-title">
                                        <h3>Projects</h3>
                                        <p>Designed to increase the value of FONTANA. Contribute and participate in FONTANA ecosystem projects for specified rewards.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="mb-4 d-flex">
                            <div className="feature-single-box upper5 flex-fill d-flex flex-column">
                                <div className="feature-box-inner flex-fill d-flex flex-column">
                                    <div className="feature-icon reward-icon" style={{ color: '#00b4d8' }}>
                                        <img
                                            src={Cerulean}
                                            alt="Cerulean sovereign token, Cerulean DAO"
                                            className="reward-icon-img"
                                        />
                                    </div>
                                    <div className="feature-title">
                                        <h3>Cerulean </h3>
                                        <p>Sovereign Token of the ecosystem. Each token will be backed by an initial value with USDT, setting the credibility of the token. </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
          
      </Container>
    </Container>
  );
}
export default Home3;
